import React from 'react';
export function AuthorSection() {
  return <section className="w-full bg-black" data-id="element-17">
      <div className="py-16 md:py-20 px-4 text-center max-w-3xl mx-auto space-y-4" data-id="element-18">
        <p className="font-['Crimson_Text'] text-sm md:text-base tracking-[0.2em] uppercase text-zinc-400" data-id="element-19">
          Sobre este libro
        </p>
        <p className="font-['Crimson_Text'] text-lg md:text-xl text-zinc-200 leading-relaxed" data-id="element-20">
          Investigación periodística basada en fuentes verificadas, cobertura
          regional y documentos públicos. Cada hecho citado tiene respaldo
          documental.
        </p>
      </div>

      {/* Bottom gold line */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/40 to-transparent" data-id="element-21" />
    </section>;
}